import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Nav, Container, Row, Col, Button, Modal, Form } from 'react-bootstrap';
import Chart from 'react-apexcharts';


function ReportFrameworks({ dados }) {

    const polarAreaOptions = {
        labels: [
            "Objetivo 6",
            "Objetivo 8",
            "Objetivo 12",
            "Objetivo 16",
            "Objetivo 17"
        ],
        legend: {
            fontSize: 14,
            offsetY: 0,
            clusterGroupedSeries: true,
            clusterGroupedSeriesOrientation: "vertical",
            markers: {
                size: 7
            },
            itemMargin: {
                vertical: 0
            }
        }
    }

    const polarAreaOptionsSeries = [
        42,
        47,
        52,
        58,
        65
    ]

    return (
        <>
            <Row className='d-flex' style={{ height: 'calc(100vh - 480px)' }}>
                <Col md={4}>
                    <Form.Select size="sm" className="mb-4" style={{ maxWidth: '250px' }}>
                        <option>Selecione o Framework</option>
                        {dados['Frameworks ESG Globais e Locais'] && Object.keys(dados['Frameworks ESG Globais e Locais'])?.length > 0 ? Object.keys(dados['Frameworks ESG Globais e Locais']).map((item, index) => (
                            dados['Frameworks ESG Globais e Locais'][item] !== ' - ' &&
                            <option>{item}</option>
                        )) : ''}
                    </Form.Select>
                    <Chart options={polarAreaOptions} series={polarAreaOptionsSeries} type="polarArea" width="70%" />
                </Col>
                <Col md={8} style={{flexFlow: 'column'}}>
                    <h6 className='w-100 mb-2 display--block'>Objetivos de Desenvolvimento Sustentável ONU</h6>
                    <Row className='scrollbar d-flex pt-5' style={{ height: 'calc(100vh - 510px)' }}>
                        {[1, 2, 3].map((item, idx) => (
                            <Col key={idx} md={6}>

                                <div className='rect-content-risks'>
                                    <div className='rect-header'>
                                        <div className={'rect-tag ambiental display--inline me-3'}>Ambiental</div>
                                        <div className={'rect-tag social display--inline'}>Social</div>
                                    </div>
                                    {/* <img style={{width: '36px', position: 'absolute', right: '8px', top: '8px'}} src={process.env.PUBLIC_URL + '/static/imagens/ods-ods-16.png'} alt='ODS 16' /> */}
                                    <p className='rect-tx-1'>Objetivo 8</p>
                                    <p className='rect-tx-2' style={{ height: '90px' }}><img className='float--l' style={{width: '40px', marginRight: '8px'}} src={process.env.PUBLIC_URL + '/static/imagens/ods-ods-16.png'} alt='ODS 16' /> Promover o crescimento econômico sustentado, inclusivo e sustentável, emprego pleno e produtivo e trabalho decente para todas e todos.</p>
                                    <div className='rect-link cursor-pointer'><i className="bi bi-plus-circle-fill"></i></div>
                                </div>
                            </Col>

                        ))}
                    </Row>
                </Col>
            </Row>
            {/* <Row className='scrollbar d-flex' style={{ height: 'calc(100vh - 480px)' }}>
                {dados['Frameworks ESG Globais e Locais'] && Object.keys(dados['Frameworks ESG Globais e Locais'])?.length > 0 ? Object.keys(dados['Frameworks ESG Globais e Locais']).map((item, index) => (
                    dados['Frameworks ESG Globais e Locais'][item] !== ' - ' &&
                    <Col key={index} md={4}>
                        <div className='rect-content-risks'>
                            <p className='rect-tx-1'>{item}</p>
                            <p className='rect-tx-2' style={{ height: '90px' }}>{dados['Frameworks ESG Globais e Locais'][item]}</p>
                        </div>
                    </Col>
                )) : <Row><span className="fs-6">Nenhum item encontrado</span></Row>}
            </Row> */}
        </>
    )
}

export default ReportFrameworks;